import React, {useCallback} from 'react';
import {ExecutableModalProps} from "../../models/Modals";
import ExecutableModal from "../executableModal/ExecutableModal";
import {Button} from "antd";

type TwsSyncRangeWarningModalProps = ExecutableModalProps<{
  onApply: () => void | Promise<void>;
}>;

const TwsSyncRangeWarningModal = ({ onApply, handler }: TwsSyncRangeWarningModalProps) => {
  const submitClick = useCallback(() => {
    void onApply();
    handler.executeClose();
  }, [onApply]);

  const Footer = (
    <>
      <Button key={'cancel'} onClick={handler.executeClose}>
        Cancel
      </Button>
      <Button key={'apply'} type="primary" onClick={submitClick}>
        I understand
      </Button>
    </>
  );

  return (
    <ExecutableModal
      handler={handler}
      title={'TWS Sync Warning'}
      footer={Footer}
    >
      <p>
        Please note: The selected date range exceeds two days.
        Executing the synchronisation for such period of time may take a long time.
      </p>
    </ExecutableModal>
  );
};

export default TwsSyncRangeWarningModal;